import type { DefineDateTimeFormat } from 'vue-i18n';
import type { I18N_AVAILABLE_LOCALES } from './locales.ts';

export enum DatetimeFormatType {
  SHORT_DATE = 'shortDate',
  DATETIME = 'datetime',
  ONLY_HOUR = 'onlyHour',
  /**
   * @deprecated
   */
  DATE_ONLY_ISO = 'dateOnlyISO',
}

export const datetimeFormatsConfig: DefineDateTimeFormat = {
  // example: 28/04/2000
  [DatetimeFormatType.SHORT_DATE]: {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  },
  // example: 28/04/2000, 02:00
  [DatetimeFormatType.DATETIME]: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  },
  // example: 12:13
  [DatetimeFormatType.ONLY_HOUR]: {
    hour: '2-digit',
    minute: '2-digit',
  },
};

export function generateDatetimeFormatsConfig(
  locales: typeof I18N_AVAILABLE_LOCALES,
): Record<string, DefineDateTimeFormat> {
  return locales.reduce(
    (acc, locale) => {
      acc[locale] = datetimeFormatsConfig;
      return acc;
    },
    {} as Record<string, DefineDateTimeFormat>,
  );
}
